import React from 'react';
import { useNotifications } from '../../contexts/NotificationContext';
import NotificationCard from '../../components/notifications/NotificationCard'; // Optional, reusable component

const NotificationsPage: React.FC = () => {
  const { notifications } = useNotifications();

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">All Notifications</h1>
      {notifications.length === 0 ? (
        <p className="text-gray-500">You have no notifications.</p>
      ) : (
        <div className="space-y-4">
          {notifications.map((n) => (
            <NotificationCard key={n._id} notification={n} />
          ))}
        </div>
      )}
    </div>
  );
};

export default NotificationsPage;
